export { default } from "~/components/ui/BannerGrid"

// Banner-grid sections (filetas) are typically thin banners (~100-180px tall).
// Reserve a min-height matching real content to prevent CLS.
export function LoadingFallback() {
  return <div className='w-full min-h-[120px] bg-base-200/30 animate-pulse' />
}
